(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/areas/popup-area.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/areas/popup-area.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, gsap) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  var DialogPopupsArea = function (_svs$components$dialo) {
    _inherits(DialogPopupsArea, _svs$components$dialo);

    var _super = _createSuper(DialogPopupsArea);

    function DialogPopupsArea(options) {
      var _this;

      _classCallCheck(this, DialogPopupsArea);

      _this = _super.call(this);
      _this.log = new svs.core.log.Logger('DialogPopupsArea');
      _this.name = svs.components.dialog.area.POPUP;
      _this.items = [];
      _this.el = options.el;
      _this.options = options;
      _this.at = 0;
      _this.hasRendered = false;
      _this.isOpen = false;
      _this.offsetHeight = 50;

      _this.init();

      return _this;
    }

    _createClass(DialogPopupsArea, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.el = document.createElement('div');
        this.el.className += 'js-dialog-items dialog-items js-dialog-popup-items dialog-popup-items';
        this.options.attachTo.appendChild(this.el);
        window.addEventListener('resize', function () {
          _this2.resize();
        });
        window.addEventListener('orientationchange', function () {
          setTimeout(function () {
            _this2.resize();
          }, 400);
        });
      }
    }, {
      key: "resize",
      value: function resize() {
        var currentItem = this.items[0];

        if (currentItem) {
          var windowH = this.getWindowAvialiableHeight();

          if (windowH > this.items[0].height) {
            currentItem.setScrollableHeight('auto'); 

            gsap.set(this.el, {
              height: currentItem.el.clientHeight
            });
          } else {
            currentItem.setScrollableHeight(windowH); 

            gsap.set(this.el, {
              height: windowH
            });
          }
        }
      }
    }, {
      key: "add",
      value: function add(dialog) {
        var _this3 = this;

        if (dialog) {
          var itemsToAdd = []; 

          var toasters = this.options.areas[svs.components.dialog.area.TOASTER]; 

          if (toasters && toasters.count()) {
            this.log.debug('Converted all toasters to popups');
            itemsToAdd = toasters.convertToPopups() || [];
          } 


          itemsToAdd.push(dialog);
          itemsToAdd.forEach(function (dialog) {
            dialog.el.className += ' dialog-popup-item';

            _this3.append(dialog);
          }); 

          if (!this.isOpen) {
            this.open();
          }
        }
      }
    }, {
      key: "getWindowAvialiableHeight",
      value: function getWindowAvialiableHeight() {
        return window.innerWidth > 620 ? window.innerHeight - 48 : window.innerHeight - 24;
      }
    }, {
      key: "getNeededHeight",
      value: function getNeededHeight() {
        if (this.getWindowAvialiableHeight() > this.items[0].height) {
          return this.items[0].height;
        }

        return this.getWindowAvialiableHeight();
      }
    }, {
      key: "getHeight",
      value: function getHeight() {
        if (window.innerHeight < this.items[0].height) {
          return window.innerHeight;
        }

        return this.items[0].height;
      }
    }, {
      key: "open",
      value: function open() {
        var _this4 = this;

        this.isOpen = true;
        this.log.debug('First dialog to be opened');
        this.el.classList.remove('dialog-items-closed');
        this.emit('open', {
          area: this.area
        });
        this.emit('changed', this.items[0]);
        this.resize();
        var tl = gsap.timeline();
        tl.fromTo(this.el, {
          opacity: 0,
          scale: 0.8,
          height: this.getNeededHeight()
        }, {
          duration: 0.15,
          opacity: 1,
          scale: 1,
          ease: 'power1.out',
          height: this.getNeededHeight(),
          onComplete: function onComplete() {
            _this4.items[0].reveal();
          }
        });
        tl.fromTo(this.el, {
          boxShadow: '0'
        }, {
          duration: 0.2,
          boxShadow: '0 0 48px 4px rgba(0, 0, 0, .5)'
        });
      }
    }, {
      key: "next",
      value: function next() {
        var _this5 = this;

        this.emit('changed', this.items[0]);
        this.log.debug('Next dialog to be opened');
        gsap.to(this.el, {
          duration: 0.15,
          height: this.getHeight(),
          onComplete: function onComplete() {
            _this5.resize();

            _this5.items[0].next();
          }
        });
      }
    }, {
      key: "closeFromOutside",
      value: function closeFromOutside() {
        if (this.items[0]) {
          this.items[0].close();
        }
      }
    }, {
      key: "close",
      value: function close() {
        var _this6 = this;

        this.log.debug('No more dialogs here, close container');
        gsap.to(this.el, {
          duration: 0.2,
          boxShadow: 0,
          opacity: 0,
          scale: 0.9,
          delay: 0.1,
          onComplete: function onComplete() {
            _this6.el.classList.add('dialog-items-closed');

            _this6.isOpen = false;

            _this6.emit('close', {
              area: _this6.area
            });

            _this6.log.debug('Container closed!'); 


            if (_this6.items.length) {
              _this6.open();
            }
          }
        });
      }
    }, {
      key: "append",
      value: function append(dialog) {
        var _this7 = this;

        this.log.debug('Append dialog to be opened');
        dialog._queue = this;
        dialog.area = this.name;
        dialog.on('closed', this, function () {
          _this7.log.debug('A dialog was closed, now handle it.');

          _this7.unload(dialog);
        });
        dialog.on('revealed', this, function () {
          _this7.log.debug('A dialog was revealed.'); 

        });

        if (this.items.length && this.items[0].requireHandshake) {
          this.items.splice(1, 0, dialog);

          if (this.el.children.length > 1) {
            this.el.insertBefore(dialog.el, this.el.children[1]);
          } else {
            this.el.appendChild(dialog.el);
          }
        } else {
          this.items.push(dialog);
          this.el.appendChild(dialog.el);
        }

        dialog.setDimensions();
        dialog.setupAnimations();
      }
    }, {
      key: "unload",
      value: function unload(dialog) {
        var _this8 = this;

        this.items.forEach(function (item, i) {
          if (item._id === dialog._id) {
            _this8.items.splice(i, 1);

            _this8.el.removeChild(item.el);
          }
        });

        if (!this.items.length) {
          this.close();
        } else {
          this.next();
          this.status();
        }
      }
    }, {
      key: "status",
      value: function status() {
        this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
      }
    }, {
      key: "count",
      value: function count() {
        return this.items.length;
      }
    }]);

    return DialogPopupsArea;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.DialogPopupsArea = DialogPopupsArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.POPUP = 'popup';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.POPUP] = svs.components.dialog.DialogPopupsArea;
})(svs, gsap);
 })(window);